import { AxiosRequestConfig } from 'axios';

export const axiosLanguageConfig: AxiosRequestConfig = {
  headers: {
    'Content-type': 'application/json; charset=utf-8',
    Accept: 'application/json; charset=utf-8',
  },
};
